import React from "react";

// CHELA wordmark. The dot over "E" doubles as a subtle "helping hand / point of connection".
export const Logo = ({ className = "", dark = false, size = "text-2xl" }) => {
  const color = dark ? "#FAF8F5" : "#121316";
  return (
    <span
      className={`font-display font-extrabold tracking-tight inline-flex items-center ${size} ${className}`}
      style={{ color, letterSpacing: "-0.02em" }}
    >
      CH
      <span className="relative inline-block">
        E
        <span
          className="absolute -top-[0.18em] left-1/2 -translate-x-1/2 rounded-full"
          style={{ width: "0.16em", height: "0.16em", background: "var(--chela-saffron)" }}
        />
      </span>
      LA
    </span>
  );
};

export default Logo;
